const URL = {
  SEND_MAIL: 'rest/model/atg/userprofiling/ProfileActor/sendCardByEmail'
};

export const init = () => {
  const printButton = cube.$id('js-print-barcode');
  const sendButton = cube.$id('js-send-barcode');

  if (printButton)
    printButton.on('click', printBarcode);

  if (sendButton)
    sendButton.on('click', sendBarcode);
};


const printBarcode = () => {
  window.print();
};


const sendBarcode = e => {
  const button = e.target;
  const mail = cube.$id('js-customer-mail');

  button.disabled = true;

  cube.ajax.post(URL.SEND_MAIL)
    .onSuccess(response => {
      if (ajaxError(response, button))
        return;

      button.disabled = false;
      cube.alert.success(window.Messages('loyalty.barcode.send_card.success', mail.textContent));
    })
    .onError(response => ajaxError(response, button))
    .call();
};


/**
 * Display an error if the XHR returns error(s).
 *
 * @param {Json} response The XHR response.
 * @param {HTMLElement} button The form submit button.
 * @returns {Boolean}
 */
const ajaxError = (response, button) => {
  if (
    typeof response === 'string' ||
    typeof response === 'object' && response.responseTO && response.responseTO.errors[0] && response.responseTO.errors[0].message
  ) {
    if (response === 'string')
      cube.alert.error(window.Messages('error.oc.call'));
    else if (typeof response === 'object' && response.responseTO && response.responseTO.errors[0])
      cube.alert.error(response.responseTO.errors[0].message);

    button.disabled = false;

    return true;
  }

  return false;
};



// WEBPACK FOOTER //
// ./src/customer/account/account-barcode.js